import { render, staticRenderFns } from "./CommandeInfos.vue?vue&type=template&id=084629ab&"
import script from "./CommandeInfos.vue?vue&type=script&lang=js&"
export * from "./CommandeInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084629ab')) {
      api.createRecord('084629ab', component.options)
    } else {
      api.reload('084629ab', component.options)
    }
    module.hot.accept("./CommandeInfos.vue?vue&type=template&id=084629ab&", function () {
      api.rerender('084629ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommandeInfos.vue"
export default component.exports